import { ValidationGroupContext } from "@/contexts/ValidationGroupProvider";
import { useContext, useMemo } from "react";
import type { ValidationGroupContextType } from "@/types/Validations";

export type UseValidationGroupReturn = {
  isValidated: ValidationGroupContextType["isValidated"];
  registerValidation: ValidationGroupContextType["registerValidation"];
  groupName: ValidationGroupContextType["groupName"];
  error: string | null;
  setError: (errorMessage: string | null) => void;
  setErrors: ValidationGroupContextType["setErrors"];
};

export function useValidationGroup(name: string): UseValidationGroupReturn {
  const context = useContext(ValidationGroupContext);

  if (!context) {
    throw new Error(
      "useValidationGroup must be used within a ValidationGroupProvider",
    );
  }

  return useMemo(() => {
    return {
      isValidated: context.isValidated,
      registerValidation: context.registerValidation,
      groupName: context.groupName,
      error: context.errors[name] ?? null,
      setError: (errorMessage: string | null) => {
        context.setErrors((prev) => ({
          ...prev,
          [name]: errorMessage,
        }));
      },
      setErrors: context.setErrors,
    };
  }, [context, name]);
}
